import { render, staticRenderFns } from "./WorkListItem.vue?vue&type=template&id=d5c04a66"
import script from "./WorkListItem.vue?vue&type=script&lang=js"
export * from "./WorkListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports